export default {
  order: {},
  // 取消原因
  reasons: [],
  // 退单原因
  refundReasons: [],
  // 被预约服务人员
  orderServe: {},
  // 退款详情
  refundDetail: {},
  // 支付结果页配置
  paySettings: {}
}
